import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_BASE,
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' }
});

// Attach owner JWT from localStorage
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('ownerToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;

  // Attach visitor session token if available
  const visitorToken = sessionStorage.getItem('visitorToken');
  if (visitorToken) config.headers['X-Visitor-Token'] = visitorToken;

  return config;
});

// Handle 401 globally
api.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response?.status === 401) {
      const isOwnerRoute = error.config.url?.includes('/owner/') ||
                           error.config.url?.includes('/auth/me');
      if (isOwnerRoute) {
        localStorage.removeItem('ownerToken');
        localStorage.removeItem('ownerData');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

// ─── Auth ─────────────────────────────────────────────────────────────────────
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  me: () => api.get('/auth/me'),
};

// ─── Visitor ──────────────────────────────────────────────────────────────────
export const visitorAPI = {
  scan: (doorId) => api.get(`/scan/${doorId}`),
  call: (doorId) => api.post('/call', { doorId }),
  message: (doorId, message) => api.post('/message', { doorId, message }),
  package: (doorId, note) => api.post('/package', { doorId, note }),
};

// ─── Owner Dashboard ──────────────────────────────────────────────────────────
export const ownerAPI = {
  dashboard: () => api.get('/owner/dashboard'),
  setMode: (mode) => api.post('/owner/set-mode', { mode }),
  setCallStrategy: (strategy) => api.post('/owner/call-strategy', { strategy }),
  addFamilyMember: (data) => api.post('/owner/add-family-member', data),
  removeFamilyMember: (memberId) => api.delete(`/owner/family-member/${memberId}`),
  toggleFamilyMember: (memberId) => api.patch(`/owner/family-member/${memberId}/toggle`),
  getLogs: (params) => api.get('/owner/logs', { params }),
  getQRCode: () => api.get('/owner/qr-code'),
};

export default api;
